<template>
  <b-card title="Online Payments">
    <payment-order-filter @filtersUpdated="filtersChangeHandler" />
    <payment-order-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import PaymentOrderFilter from '@/components/Accounts/PaymentOrders/PaymentOrderFilter.vue'
import PaymentOrderList from '@/components/Accounts/PaymentOrders/PaymentOrderList.vue'

export default {
  components: {
    BCard,
    PaymentOrderList,
    PaymentOrderFilter,
  },
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}
</script>
